import React, { useState, useEffect } from 'react';
import './updatedata.css';

export default function Updatedata() {
    const [isUpdating, setIsUpdating] = useState(false);

    // بارگذاری وضعیت اولیه از سرور هنگام بارگذاری صفحه
    useEffect(() => {
        fetch('http://185.164.73.170:5000/api/status')
            .then(response => response.json())
            .then(data => {
                setIsUpdating(data.updateStatus); // وضعیت آپدیت را از سرور می‌خوانیم
            })
            .catch(error => {
                console.error('Error fetching update status:', error);
            });
    }, []); // فقط یک‌بار هنگام بارگذاری صفحه اجرا می‌شود

    // تغییر وضعیت زمانی که چک‌باکس تیک خورده یا برداشته می‌شود
    const handleToggleUpdate = () => {
        const newStatus = !isUpdating; // وضعیت جدید تیک یا غیر تیک

        // ارسال وضعیت جدید به سرور
        fetch('http://185.164.73.170:5000/api/status', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updateStatus: isUpdating }), // ارسال وضعیت جدید به سرور
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setIsUpdating(newStatus); // در صورت موفقیت، وضعیت محلی (state) را به روز می‌کنیم
                }
            })
            .catch(error => {
                console.error('Error updating status:', error);
                // در صورت بروز خطا، وضعیت محلی را به حالت قبلی برمی‌گردانیم
                setIsUpdating(!newStatus);
            });
    };

    return (
        <div className='updatedatapage'>
            <label>
                <input
                    type="checkbox"
                    checked={isUpdating} // اگر isUpdating true باشد، چک‌باکس تیک می‌خورد
                    onChange={handleToggleUpdate} // فراخوانی برای تغییر وضعیت
                />
                فعال کردن وضعیت آپدیت
            </label>
            <div className={`status-message ${isUpdating ? 'active' : 'inactive'}`}>
                {isUpdating ? 'وضعیت آپدیت فعال است.' : 'وضعیت آپدیت غیرفعال است.'}
            </div>
        </div>
    );
};
